
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from "react";
//--------Material React Table------//
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table"; //material-react-table
// import { Box, Button } from "@mui/material";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import moment from "moment";

function CommonMatrialReactTable({
  columns,
  data,
  enableRowActions,
  renderRowActionMenuItems,
//   MainHeading,
//   ReportHeading,
//   startdate,
//   enddate,
//   columnGrouping,
//   columnsVisibility,
//   setColumnOrder,
//   columnOrder,
//   setColumnVisibility,
//   rowCount,
//   state
}) {
  // console.log(columnsVisibility, "columnsVisibility<-------->")
  // console.log(setColumnVisibility, "setColumnVisibility<-------->")

  const table = useMaterialReactTable({
    columns,
    data,
    enableRowActions,
    renderRowActionMenuItems,
    // enableColumnResizing: true,
    // enableGrouping: true,
    // enableStickyHeader: true,
    // enableStickyFooter: true,
    // enableRowSelection: true,
    // enableColumnOrdering: true,
    // sortDescFirst: true,
    // enableColumnFilterModes: true,
    // enablePagination: true,
    // onColumnOrderChange : setColumnOrder,
    // onColumnVisibilityChange: setColumnVisibility,
    // rowCount : rowCount ,

    // muiTableBodyProps: {
    //   sx: () => ({
    //     "& tr:nth-of-type(even)": {
    //       backgroundColor: "var(--datatable-row-background-color)",
    //       //'rgb(237 237 233 / 63%)'
    //     },
    //     "& td": {
    //       borderRight: "1px solid var(--datatable-row-background-hover-color)",
    //       lineHeight: "16px",
    //       fontWeight: "400",
    //       fontSize: "12px",
    //       color: "var(--primary-color-800)",
    //       fontFamily: "Inter",
    //     },

    //     "& tr": {
    //       lineHeight: "16px",
    //       fontWeight: "400",
    //       fontSize: "12px",
    //       color: "var(--primary-color-800)",
    //       fontFamily: "Inter",
    //     },
    //   }),
    // },
    // muiTableHeadCellProps: {
    //   sx: (theme) => ({
    //     background: "var(--datatable-row-background-color)", //'#e9e9e9',
    //     borderRight: "1px solid var(--datatable-row-background-hover-color)",
    //     lineHeight: "16px",
    //     fontWeight: "500",
    //     fontSize: "14px",
    //     color: "var(--primary-color-800)",
    //     fontFamily: "Inter",
    //   }),
    // },
    // muiToolbarAlertBannerProps: {
    //   isError: () => ({
    //     color: "error",
    //     children: "Error loading data",
    //   }),
    //   sx: (theme) => ({
    //     background: "var(--datatable-row-background-color)", //'#e9e9e9',
    //     lineHeight: "16px",
    //     fontWeight: "500",
    //     fontSize: "14px",
    //     color: "var(--primary-color-800)",
    //     fontFamily: "Inter",
    //   }),
    // },
    // muiSelectCheckboxProps: {
    //   sx: (theme) => ({
    //     lineHeight: "16px",
    //     fontWeight: "400",
    //     fontSize: "12px",
    //     color: "var(--prinary-color-800)",
    //     fontFamily: "Inter",
    //   }),
    // },
    // muiSelectAllCheckboxProps: {
    //   sx: (theme) => ({
    //     lineHeight: "16px",
    //     fontWeight: "400",
    //     fontSize: "12px",
    //     color: "var(--prinary-color-800)",
    //     fontFamily: "Inter",
    //   }),
    // },
    // muiTableContainerProps: { sx: { maxHeight: "fit-content" } },
    // muiPaginationProps: {
    //   rowsPerPageOptions: [25, 50, 100, 300, 500, 1000],
    // },
    // initialState: {
    //   density: "compact",
    //   expanded: true, //expand all groups by default
    //   grouping: [], //columnGrouping, //an array of columns to group by by default (can be multiple)
    //   pagination: { pageIndex: 0, pageSize: 25 },
    //   showColumnFilters: false,
    //   // columnVisibility: columnsVisibility,
    //   columnOrder : columnOrder 

    //   // sorting: { id: "Name", desc: false }, //sort by state by default
    // },
    // renderTopToolbarCustomActions: ({ table }) => (
    //   <Box
    //     sx={{
    //       display: "flex",
    //       gap: "1rem",
    //       p: "0.5rem",
    //       flexWrap: "wrap",
    //     }}
    //   >
    //     <Button
    //       // size="small"
    //       className="btn btn-sm btn-secondary"
    //       style={{ display: "flex" }}
    //       color="primary"
    //       //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
    //       onClick={() => onBtExport([], "AllData")}
    //       startIcon={<FileDownloadIcon />}
    //       variant="contained"
    //     >
    //       Export All In Excel
    //     </Button>
    //     <Button
    //       // size="small"
    //       class="btn btn-sm btn-secondary"
    //       style={{ display: "flex" }}
    //       color="primary"
    //       //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
    //       onClick={() =>
    //         downloadPDF("", "alldata", table.getVisibleFlatColumns())
    //       }
    //       startIcon={<FileDownloadIcon />}
    //       variant="contained"
    //     >
    //       EXPORT ALL IN PDF
    //     </Button>
    //     <Button
    //       // size="small"
    //       className="btn btn-sm btn-secondary"
    //       style={{ display: "flex" }}
    //       color="primary"
    //       //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
    //       onClick={() => onBtExport(table.getSelectedRowModel().rows, "")}
    //       startIcon={<FileDownloadIcon />}
    //       variant="contained"
    //       disabled={
    //         !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
    //       }
    //     >
    //       EXPORT SELECTED ROWS IN EXCEL
    //     </Button>
    //     <Button
    //       // size="small"
    //       class="btn btn-sm btn-secondary"
    //       style={{ display: "flex" }}
    //       disabled={
    //         !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
    //       }
    //       //only export selected rows
    //       onClick={() =>
    //         downloadPDF(
    //           table.getSelectedRowModel().rows,
    //           "selectedrow",
    //           table.getVisibleFlatColumns()
    //         )
    //       }
    //       startIcon={<FileDownloadIcon />}
    //       variant="contained"
    //     >
    //       EXPORT SELECTED ROWS IN PDF
    //     </Button>
    //     <Button
    //       // size="small"
    //       className="btn btn-sm btn-secondary"
    //       style={{ display: "flex" }}
    //       color="primary"
    //       //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
    //       onClick={() => onBtExport(table.getRowModel().rows, "")}
    //       startIcon={<FileDownloadIcon />}
    //       variant="contained"
    //     >
    //       Export Page Rows In Excel
    //     </Button>
    //     <Button
    //       disabled={table.getRowModel().rows.length === 0}
    //       //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
    //       onClick={() =>
    //         downloadPDF(
    //           table.getRowModel().rows,
    //           "selectedrow",
    //           table.getVisibleFlatColumns()
    //         )
    //       }
    //       class="btn btn-sm btn-secondary"
    //       style={{ display: "flex" }}
    //       variant="contained"
    //       startIcon={<FileDownloadIcon />}
    //     >
    //       Export Page Rows In Pdf
    //     </Button>
    //   </Box>
    // ),
    // state: state
  });

  return (
    <>
      <MaterialReactTable
        table={table} 
        renderRowActionMenuItems={renderRowActionMenuItems}
      />
    </>
  );
}

export default CommonMatrialReactTable;